// import libs
import debounce from 'lodash/debounce';
import { queryString, getHashParam, sendMessage, DOMReady } from './utils';
import './jscookie';
import './polyfills/Fetch';

// import base styles'
import './app.scss';

const untitled = queryString( 'untitled' );
const ridingTool = {
	ajax: '/gnca-ajax-redesign/riding-lookup-2',
	domain: '',
	cookieName: 'gnca_riding_look_up',
	states: {
		error: 'c-ridingLookup--error',
		filled: 'c-ridingLookup__address--filled',
		loading: 'c-ridingLookup--loading',
		success: 'c-ridingLookup--success',
		hidden: 'is-hidden',
	},
	election: '',
	address: '',
	province: '', // legacy
	year: '', // legacy
	$elem: false,
	$address: false,
	$errors: false,
	$form: false,
	$submitButton: false,
	$result: false,
	$link: false,
	$desc: false,
	$cta: false,

	/**
	 * Initialize click listeners for form buttons of the riding tools
	 */
	init: function() {
		// config
		this.domain = 'https://globalnews.ca';
		if ( queryString( 'preprod' ) ) {
			this.domain = 'https://globalnews-ca-develop.go-vip.net';
		}
		if ( queryString( 'local' ) ) {
			this.domain = 'https://local.globalnews.ca';
		}
		this.election = queryString( 'election' );
		this.province = queryString( 'province' );
		this.year = queryString( 'year' );

		if ( ! this.election && ! this.year ) {
			console.error( 'Riding Tool Error: Undefined election' );
			return;
		}

		this.$elem = document.querySelector( '.c-ridingLookup' ); 
		this.$submitButton = document.querySelector( '.c-ridingLookup__submit' );
		this.$form = document.querySelector( '.c-ridingLookup__form' );
		this.$errors = document.querySelectorAll( '.c-ridingLookup__note' );
		this.$address = document.querySelector( '#riding-address' );
		this.$desc = document.querySelector( '.c-ridingLookup__desc' );
		this.$notes = document.querySelector( '.c-ridingLookup__notes' );
		this.$result = document.querySelector( '.c-ridingLookup__result' );
		this.$link = document.querySelector( '.c-ridingLookup__link' );
		this.$linkLabel = document.querySelector( '.c-ridingLookup__linkLabel' );

		// Set province and related configurations
		const label = this.province ? this.province : 'federal';
		document.querySelector('.c-ridingLookup__province').textContent = label;
		document.title = `${label} Riding Lookup Tool`;

		// give widget unique id in case there are multiple lookup tools on the page
		var olddata = Cookies.get( this.cookieName );
		if ( olddata ) {
			olddata = JSON.parse( olddata );
			if ( 'success' === olddata.status ) {
				this.showResults( olddata, false );
				this.$elem.classList.add( this.states.success );
			}
		}

		// Watch for address change
		this.$address.addEventListener( 'change', ( e ) => {
			if ( this.$address.value.length > 0 ) {
				this.$address.classList.add( this.states.filled );
			} else {
				this.$address.classList.remove( this.states.filled );
			}
		});

		// submit riding lookup request
		this.$submitButton.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			// Reset errors
			[].forEach.call( this.$errors, $err => this.hide( $err ) );

			// Track riding lookup
			this.track({
				eventType: 'click',
				action: 'riding lookup | search',
				target: false,
			});

			this.address = this.$address ? this.$address.value : '';
			if ( this.address.length > 5 ) {
				// prep form
				this.$elem.classList.remove( this.states.error );
				this.$elem.classList.add( this.states.loading );

				// call ajax service
				let params = {
					'address': this.address,
					'election': this.election
				};

				// Backward compatibility.
				if ( this.province ) {
					params.province =  this.province;
				}

				// Backward compatibility.
				if ( this.year ) {
					params.year =  this.year;
				}

				this.updateHeight();

				fetch( `${this.domain}${this.ajax}/${encodeURI( JSON.stringify( params ) )}` )
						.then( response => response.text() )
						.then( ( content ) => {
							this.$elem.classList.remove( this.states.loading )

							const data = JSON.parse( content );
							this.showResults( data, true );
						});
			} else if ( this.address.length > 0 ) {
				this.showError( 3 );
			} else {
				this.$address.classList.add( this.states.empty );
				this.showError( 1 );
			}
		});

		// Add CTA when configured.
		// Note that the CTA remains hidden beyond mobile breakpoint.
		var cta = queryString( 'cta' );
		var ctaImage = queryString( 'image' );
		var ctaLink = queryString( 'link' );
		if ( cta && ctaImage && ctaLink ) {
			var $cta = document.querySelector( '.c-ridingLookup__cta' );
			var $ctaImage = $cta.querySelector( '.c-ridingLookup__ctaImage' );
			$ctaImage.addEventListener( 'load', () => {
				this.updateHeight();
			});

			cta = decodeURIComponent( cta );
			ctaImage = decodeURIComponent( ctaImage );
			ctaLink = decodeURIComponent( ctaLink );

			$cta.classList.remove( this.states.hidden );
			$cta.setAttribute( 'href', ctaLink );
			$cta.setAttribute( 'title', cta );
			$ctaImage.setAttribute( 'src', ctaImage );
			$ctaImage.setAttribute( 'alt', cta );
		}

		// Riding link click
		var $links = document.querySelectorAll( 'a' );
		[].forEach.call( $links, ( $link ) => {
			$link.addEventListener( 'click', ( e ) => {
				const isTargetSelf = '_blank' !== this.$link.getAttribute( 'target' );
				if ( isTargetSelf ) {
					e.preventDefault();
				}

				this.track({
					eventType: 'click',
					action: 'riding lookup | ' + $link.getAttribute( 'title' ),
					target: false,
				});

				// Ensure the tracking call is made before leaving the window.
				if ( isTargetSelf ) {
					setTimeout( () => {
						var targetWindow = window;
						try {
							targetWindow = window.parent;	
						} catch ( err ) {}
						targetWindow.location.href = $link.getAttribute( 'href' );
					}, 500 );
				}
			});
		});
	},

	/**
	 * Show an error specified by error number
	 */
	showError: function( errorNum ) {
		const $errors = document.querySelectorAll( '[data-error="' + errorNum + '"]' );
		if ( $errors ) {
			[].forEach.call( $errors, $err => this.show( $err ) );
		}

		this.$elem.classList.add( this.states.error );
		this.updateHeight();

		// clear cookies when an error is encountered.
		Cookies.remove( this.cookieName );
	},

	/**
	 * Hide a dom element
	 */
	hide: function( $elem ) {
		$elem.classList.add( this.states.hidden );
	},

	/**
	 * Show a dom element
	 */
	show: function( $elem ) {
		$elem.classList.remove( this.states.hidden );
	},

	/**
	 * Show the riding tool results
	 */
	showResults: function( data, saveCookie ) {
		if ( 'success' === data.status ) {
			this.$elem.classList.add( this.states.success );

			// update profile link
			if ( data.url && data.url.length > 0 ) {
				this.$link.setAttribute( 'href', data.url );
				this.$linkLabel.textContent = data.name;
				this.show( this.$link );
			}

			if ( data.term ) {
				this.$address.value = data.term;
			}

			if ( saveCookie ) {
				if ( ! data.term ) {
					data.term = this.address;
				}

				Cookies.set( this.cookieName, JSON.stringify( data ), { expires: 1, path : '/' } );
			}
		} else {
			// Track riding lookup error.
			this.track({
				eventType: 'click',
				action: 'riding lookup | error ' + data.code,
				target: false,
			});

			if ( data.code <= 2 ) {
				// errors related to bad user input
				this.showError( 2 );
			} else {
				// errors related to open north api service disruption
				this.showError( 3 );
			}
		}
		this.updateHeight();
	},

	/**
	 * Notify parent window to update iframe height based on content height
	 */
	updateHeight: function() {
		sendMessage({
			'height': document.documentElement.offsetHeight + 2,
			'action': 'setHeight'
		});
	},

	/**
	 * Notify parent window for analytics tracking
	 */
	track: function( data ) {
		sendMessage({
			'data': data,
			'action': 'track'
		});
	},
};

DOMReady( () => {
	// initialize riding tool
	ridingTool.init();

	// Initial sizing
	ridingTool.updateHeight();

	// bind event to capture orientation change
	const resizeHandler = debounce( () => {
		ridingTool.updateHeight();
	}, 200 );

	window.addEventListener( 'orientationchange', resizeHandler );
	window.addEventListener( 'resize', resizeHandler );
});
